import { type NavigateFunction, Params } from 'react-router-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

type RouteParams = Readonly<Params<string>>

const onExportYearlyBalanceModals =
  (params: RouteParams, navigate: NavigateFunction, navigation: Navigation<NavigationPaths>) =>
  () => {
    track(trackingEvents.shiftManagement.requestYearlyExportStart, {
      export_from: 'time_tracking',
    })

    // Although the export process doesn't depend on a year and month, we
    // nest them in the same section to avoid an empty background.
    navigate(
      navigation.timeTracking.list.periodTypeYearMonthDay.exportYearlyBalance.fullPath({
        periodType: params.periodType ?? '',
        year: Number(params.year),
        month: Number(params.month),
        day: Number(params.day),
      })
    )
  }

interface DownloadAnnualBalanceActionParams {
  params: RouteParams
  navigate: NavigateFunction
  navigation: Navigation<NavigationPaths>
  showExportYearlyBalanceOption: boolean
}

export const downloadAnnualBalanceAction = ({
  params,
  navigate,
  navigation,
  showExportYearlyBalanceOption,
}: DownloadAnnualBalanceActionParams) => {
  if (!showExportYearlyBalanceOption) return null

  return {
    label: i18n.t('time_tracking.menu.download_annual_balance.title'),
    description: i18n.t('time_tracking.menu.download_annual_balance.description'),
    onClick: onExportYearlyBalanceModals(params, navigate, navigation),
  }
}
